<template>
<loader v-bind="{ loading }">
    <columns>
      <column>
        <text-input v-model="filters.search" classes="is-rounded">
          <template #right>
            <div class="buttons has-addons is-rounded">
              <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
                <icon icon="times"/>
              </action-button>
              <action-button @click="runFilters" class="is-rounded">
                <icon icon="search"/>
                <span>Search</span>
              </action-button>
            </div>
          </template>
        </text-input>
      </column>
      <column class="is-narrow is-flex align-end">
        <router-link 
          class="button is-small is-rounded"
          :to="{
            name: 'new-software'
          }">
          <icon icon="plus"/>
          <span>Software</span>
        </router-link>
      </column>
    </columns>

    <div>
      <div class="table-container">
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Software</th>
              <th>Last updated</th>
              <th class="is-narrow has-text-right">Versions</th>
              <th class="is-narrow has-text-right">Distributions</th>
              <th class="is-narrow has-text-right">Vulnerabilities</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="software in software.data" :key="software.id">
              <td>
                <router-link :to="{
                  name: 'software-manager',
                  params: {
                    software: software.id
                  }}">
                  {{ software.name }}
                </router-link>             
                <span class="has-text-grey" v-if="software.latest_version">{{ software.latest_version.code }}</span>   
              </td>
              <td>{{ software.updated_at | asCalendar }}</td>
              <td class="has-text-right">
                {{ software.versions_count }}
              </td>
              <td class="has-text-right">
                {{ software.distributions_count }}
              </td>
              <td class="has-text-right">
                {{ software.vulnerabilities_count }}
              </td>
            </tr>
          </tbody>
        </table>
        <pager 
          class="mb-1"
          :pageable="software" 
          @nav="goToPage"
          jump-controls
          context="Software"/>
      </div>
    </div>
</loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Software',

  data: () => ({
    software: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadSoftware()
  },

  methods: {
    loadSoftware() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.software = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'software',
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'software',
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    }
  },

  watch: {
    '$route': 'loadSoftware'
  }

}
</script>
